const host = process.env.REACT_APP_API_HOST;

const X_APP_VERSION = "10.0.0";

export function setSessionToken(token) {
  localStorage.setItem("st", token);
}

export function getSessionToken() {
  const token = localStorage.getItem("st");
  if (token) {
    return "Bearer " + token;
  }
  return null;
}

export function clearSessionToken() {
  localStorage.removeItem("st");
}

async function handleResponse(response) {
  var result = await response.text();

  if (response.status >= 300 || response.status < 200) {
    var requireLogin = false;
    if (response.status == 401) {
      // Clear login state if encountered unauthorized.
      clearSessionToken();
      requireLogin = true;
    }

    for (var i = 0; i < 2; i++) {
      if ((typeof result == "string" || result instanceof String) && result.startsWith("{")) {
        result = JSON.parse(result);
      } else {
        break;
      }
    }

    const errorReturn = {
      "error": result.code || response.status,
      "message": result.message || result.error || result,
      "requireLogin": requireLogin,
    };
    console.error("api error", errorReturn);
    return errorReturn;
  }
  return JSON.parse(result);
}

export const sendPrompt = async (phone) => {
  try {
    const response = await fetch(host + "/user/prompt", {
      method: 'POST',
      headers: {
        'X-App-Version': X_APP_VERSION,
      },
      body: JSON.stringify({
        "phoneNumber": "65" + phone,
      }),
    });

    return await handleResponse(response);
  } catch (error) {
    return {
      "error": -1,
      "message": error.message,
    }
  }
};

export const sendProof = async (promptID, otp) => {
  try {
    const response = await fetch(host + "/user/proof", {
      method: 'POST',
      headers: {
        'X-App-Version': X_APP_VERSION,
      },
      body: JSON.stringify({
        "promptID": promptID,
        "otp": otp,
      }),
    });

    return await handleResponse(response);
  } catch (error) {
    return {
      "error": -1,
      "message": error.message,
    }
  }
};

export const userBoundedLogin = async (promptID) => {
  try {
    const response = await fetch(host + "/user/login", {
      method: 'POST',
      headers: {
        'X-App-Version': X_APP_VERSION,
      },
      body: JSON.stringify({
        "promptID": promptID,
      }),
    });

    return await handleResponse(response);
  } catch (error) {
    return {
      "error": -1,
      "message": error.message,
    }
  }
};

export const userMe = async () => {
  try {
    const response = await fetch(host + "/user/me", {
      method: 'GET',
      headers: {
        'X-App-Version': X_APP_VERSION,
        'Authorization': getSessionToken(),
      }
    });

    return await handleResponse(response);
  } catch (error) {
    return {
      "error": -1,
      "message": error.message,
    }
  }
};

export const userCreate = async (promptID, name) => {
  try {
    const response = await fetch(host + "/user/create", {
      method: 'POST',
      headers: {
        'X-App-Version': X_APP_VERSION,
      },
      body: JSON.stringify({
        "promptID": promptID,
        "name": name,
        "acknowledgedAgreement": true,
      }),
    });

    return await handleResponse(response);
  } catch (error) {
    return {
      "error": -1,
      "message": error.message,
    }
  }
};

export const getBalanceTopUpOptions = async () => {
  try {
    const response = await fetch(host + "/balance/top_up_options", {
      method: 'GET',
      headers: {
        'X-App-Version': X_APP_VERSION,
      },
    });

    return await handleResponse(response);
  } catch (error) {
    return {
      "error": -1,
      "message": error.message,
    }
  }
}

export const balanceTopUp = async (amount) => {
  try {
    const response = await fetch(host + "/balance/top_up", {
      method: 'POST',
      headers: {
        'X-App-Version': X_APP_VERSION,
        'Authorization': getSessionToken(),
      },
      body: JSON.stringify({
        "amount": amount,
      }),
    });

    return await handleResponse(response);
  } catch (error) {
    return {
      "error": -1,
      "message": error.message,
    }
  }
};

export const listProfiles = async (params = {}) => {
  try {
    let headers = {
      'X-App-Version': X_APP_VERSION,
    };
    let sessionToken = getSessionToken();
    if (sessionToken) {
      headers['Authorization'] = sessionToken;
    }

    let queries = "";
    Object.entries(params).forEach(([k, v]) => {
      queries += k + "=" + v + "&";
    });

    const response = await fetch(host + "/profiles?" + queries, {
      method: 'GET',
      headers: headers,
    });

    return await handleResponse(response);
  } catch (error) {
    return {
      "error": -1,
      "message": error.message,
    }
  }
};
